import { Checkbox as AntdCheckbox, CheckboxProps } from 'antd';
import { forwardRef } from 'react';

const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>((props, ref) => (
  <AntdCheckbox {...props} ref={ref} />
));

export default Checkbox;
